module.exports = __webpack_public_path__ + "img/rosemount-802-wireless-multi-discrete-io-transmitter-close-right.5965b37d.png";